import { render, staticRenderFns } from "./LuckyDrawList.vue?vue&type=template&id=b98dd0da"
import script from "./LuckyDrawList.vue?vue&type=script&lang=js"
export * from "./LuckyDrawList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports